import { createWebHistory, createRouter } from "vue-router";
import { Container } from "inversify";

import Login from "../components/launch_dance_class.vue";
import { trackRouter } from "vue-gtag-next";
import InfoDialog from "../components/launch_online_feis.vue";
import TuneSelector from "../components/tune_selector.vue";
import ErrorView from "../components/error.vue";
import NotFoundView from "../components/404.vue";
import IAuthenticationService from "@/interfaces/authentication_service";

const routes = [
	{
		path: "/",
		name: "",
		// component: AppUseSelector,
		component: Login,
	},
	{
		path: "/home",
		name: "home",
		// component: AppUseSelector,
		component: Login,
	},
	{
		path: "/music",
		name: "music",
		component: TuneSelector,
	},
	{
		path: "/login",
		name: "login",
		component: Login,
	},
	{
		path: "/info",
		name: "info",
		component: InfoDialog,
	},
	{
		path: "/error",
		name: "error",
		component: ErrorView,
	},
	// catch anything not matched above and show the 404 page
	{
		path: "/:pathMatch(.*)*",
		name: "404",
		component: NotFoundView,
	}
];

const router = createRouter({
	history: createWebHistory(),
	routes
});

// don't need to be logged in to view these pages
const openPages =
[
	"login",
	"info",
	"error",
	"home",
	"404"
];

export function setupRouterNavigationGuards(container:Container): void
{
	// this handler will make sure that the user profile is loaded before navigating to a view
	router.beforeEach((to, from, next) =>
	{
		if (!openPages.includes(<string>to.name))
		{
			next();
		}
		else
		{
			next();
		}
	});

}

trackRouter(router);

export default router;